export default {
  data() {
    return { countries: [] };
  },
  methods: {
    loadCountries() {
      this.$http
        .get("/api/v1/transactions/transferCountries")
        .then(({ data }) => (this.countries = data));
    },
  },
};
